var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scrolled)?_c('div',{staticClass:"ScrollToTopButton cursor-pointer",on:{"click":_vm.goToTop}},[_c('ScrollToTopIcon',{})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }